import React from 'react'
import { StackView } from '@planningcenter/tapestry-react'
import { PageHeading, Text, Code, Link } from '../../shared/typography'

const page = () => {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>Libraries</PageHeading>

      <Text>
        Since our API talks HTTP and JSON, you get to use off-the-shelf
        components for your language of choice.
      </Text>

      <Text>
        Since we love Ruby so much, we went ahead and built a very simple API
        wrapper library called{' '}
        <Link to="https://github.com/planningcenter/pco_api_ruby" external>
          pco_api
        </Link>
        . <Code>gem install</Code> it, and you’ll be building cool stuff in no
        time!
      </Text>
    </StackView>
  )
}

export default page
